import store from "@/store/store";

// Patterns are imported via the config_module.js to stay consistant with the PHP package
export const vatNumberValid = vatNumber => {
  const PATTERNS = store.state.config["vat_number_validation_patterns"];

  if (typeof vatNumber !== "string") {
    return false;
  }

  const normalizedVatNumber = vatNumber.trim().toUpperCase();

  const country = normalizedVatNumber.slice(0, 2);

  if (!PATTERNS[country]) {
    return false;
  }

  const vatBody = normalizedVatNumber.slice(2);

  return new RegExp("^" + PATTERNS[country] + "$").test(vatBody);
};
